/*******************************************************************************
 * Copyright (c) 2023 GetChkd
 *
 * All rights reserved.
 *
 * Contributors:
 *  James Worthington - Initial implementation
 *  Amina Rais - Massive Improvements
 *  Version: 2.0.0
 *
 *******************************************************************************/


import * as React from 'react';
import { useDispatch } from 'react-redux';
import { Formik } from 'formik';
import { Typography } from '@mui/material';
import * as Yup from 'yup';
import { toast } from 'react-toastify';
import OrgAppUserForm from './OrgAppUserForm';
import { editApplicationUser } from '../../../../../../../../services/application/ApplicationUsers';
import { getAllApplicationUsers } from '../../../../../../../../store/reducers/applicationUsers/applicationUsersAction';

const OrgAppUserEdit = ({ handleClose,  selectedOrgAppUser }) => {
    const dispatch = useDispatch()
    const handleSubmit = async ({ roleID, detailName, detailValue }, { setSubmitting }) => {
        setSubmitting(true)
        try {
            await editApplicationUser({
                roleID, organizationApplicationUserID: selectedOrgAppUser.organizationApplicationUserID, organizationApplicationUserDetails: [
                    {
                        detailName: detailName,
                        detailValue: detailValue
                    }]
            })
            toast.success('Organization Application User was edited successfully');
            handleClose();
            await dispatch(getAllApplicationUsers()).unwrap();
            setSubmitting(false)
        } catch (error) {
            setSubmitting(false)

            toast.error(error?.response?.data?.error?.message);
        }
    }

    return (
        <>
            <Typography variant='h2' color="primary" align='center' style={{ margin: '30px' }}>Organization Application User Edit</Typography>
            <Formik
                initialValues={{
                    roleID: selectedOrgAppUser.roleID,

                    detailName: selectedOrgAppUser.organizationApplicationUserDetails[0].detailName,
                    detailValue: selectedOrgAppUser.organizationApplicationUserDetails[0].detailValue,

                }}
                validationSchema={Yup.object().shape({
                    roleID: Yup.string().required('Role is required.'),


                })}
                onSubmit={(
                    values, { setSubmitting }
                ) => {
                    handleSubmit(values, { setSubmitting })
                }
                }
            >
                {({ values, handleBlur, handleChange, setFieldValue, isSubmitting, errors, touched }) => (
                    <OrgAppUserForm
                        values={values}
                        handleBlur={handleBlur}
                        handleChange={handleChange}
                        setFieldValue={setFieldValue}
                        isSubmitting={isSubmitting}
                        handleClose={handleClose}
                        errors={errors}
                        touched={touched} />
                )}
            </Formik>
        </>
    )

}


 
export default OrgAppUserEdit;